import React, { Component } from 'react';

class Table extends Component {
  render() {
    const data = this.props.data;
    
    return (
    <table className={this.props.className}>
        <tbody>
        {Object.keys(data).map(key => 
            <tr key={key}>
                <th>{key}</th>
                <td>{data[key]}</td>
            </tr> 
        )}
        </tbody>
    </table>
    );
  }
}

export default Table;